import Field from "@/components/Field";
import { Input } from "@/components/ui/input";
import { memo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

const RoundingFieldComponent = () => {
  const { getValues } = useFormContext();
  const { t } = useTranslation();

  const hourAllocationType = useWatch({
    name: "hour_allocation_type",
  });

  if (hourAllocationType !== "period") {
    return;
  }

  return (
    <Field
      name="rounding"
      className="flex-row-reverse justify-self-start"
      label={t("projectSchedules.fields.rounding")}
      render={({ field }) => (
        <Input
          className="h-4 w-4 "
          type="checkbox"
          {...field}
          checked={getValues("rounding")}
        />
      )}
    />
  );
};

export const RoundingField = memo(RoundingFieldComponent);
